import * as React from "react";
import { BillingAccount } from "../../schema/types/account";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "antd";
import { Table } from "../../newcomponents/table/table";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectOrgNames } from "../../store/userDataSlice";
import { setOrg } from "../../store/contextSlice";

interface Props {
  account: BillingAccount;
  orgNames: string[];
}
export const AccountOrgs: React.FC<Props> = ({ account, orgNames }) => {
  const dispatch = useAppDispatch();
  const dataOrgNames = useAppSelector(selectOrgNames);

  const navigate = useNavigate();

  return (
    <div>
      {orgNames.length === 0 ? (
        <div className="flex flex-col items-center">
          <div className="text-lg mt-8 mb-4">No org found for this account</div>
          <div className="mb-8">You need to create an org to start using Control Plane</div>
          <Button
            htmlType={`button`}
            type={"primary"}
            onClick={() => navigate(`/home/org/-create?billing${account.id}`)}
          >
            Create Org
          </Button>
        </div>
      ) : (
        <>
          <Table<string>
            title={"Orgs"}
            data={orgNames}
            tableId={"account-orgs"}
            enableFilter={false}
            hideSettings
            columns={[
              {
                id: "name",
                label: "Name",
                cell: (p) => {
                  const orgName = p.row.original;

                  return (
                    <div
                      onClick={() => {
                        if (!dataOrgNames.includes(orgName)) {
                          Modal.info({
                            title: "Info",
                            content: `You are not an org member in this org, contact the org administrator to invite you to the org`,
                          });
                          return;
                        }
                        dispatch(setOrg(orgName));
                        navigate(`/console/org/${orgName}`);
                      }}
                      className="color-link cursor-pointer"
                    >
                      {orgName}
                    </div>
                  );
                },
              },
            ]}
          />
        </>
      )}
    </div>
  );
};
